import "./DashboardReports.scss";
import {formatToPersianAddComma} from "../../utils/CommaSeparator";

const DashboardReports = ({reports, type}) => {
  //   const [reports, setReports] = useState([]);
  //   useEffect(() => {

  //   }, []);
  if (reports?.length === 0) {
    return null
  }
  try {
    return type === "daily" ? (
      <div className="dashboard-report-section">
        {reports.map((report) => {
          // const url = `url('${report.background}')`;
          //alert(url);
          return (
            <div
              className="reportBtn"
              style={{
                background: `${report?.background}`,
              }}
            >
            <span>
              <img src={report?.icon} alt="" />
            </span>
              <span className="report-detail">
              <span className="report-value">
                {formatToPersianAddComma(report?.value)}
              </span>
              <span> {report?.label}</span>
            </span>
            </div>
          );
        })}
      </div>
    ) : (
      <>
        <div className="dashboard-report-section dashboard-report-fund">
          <div
            className="reportBtn"
            style={{
              background: `${reports[0]?.background}`,
            }}
          >
          <span className="fundOpt">
            <img src={reports[0]?.icon} alt="" />
            {/* <span> {reports.label2}</span> */}
          </span>
            <div className="report-container">
              {reports.map((item) => (
                <span className="report-detail">
                <span> {item?.label}</span>
                <span className="report-value">
                  {formatToPersianAddComma(item.value)}
                </span>
                <span> {item?.label2}</span>
              </span>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }catch (error){
    return <>{error.toString()}</>
  }
};

export default DashboardReports;
